import { render } from "./InventoryStatusFieldsetGroup.vue?vue&type=template&id=63b30b71"
import script from "./InventoryStatusFieldsetGroup.vue?vue&type=script&lang=js"
export * from "./InventoryStatusFieldsetGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__